<template>
  <van-col span="24">

    <van-cell :title="$t('column.select_date_range')" :value="date" @click="show = true"/>
    <van-calendar color="#887BFF" v-model="show" type="range" @confirm="onConfirm" :min-date="minDate"
                  :max-date="maxDate"/>
    <van-cell :title="$t('column.duration')" :value="total_num"/>
  </van-col>

</template>
<script>
    import axios from 'axios'

    export default {
        name: "emcee_center_select_live_time",
        data() {
            return {
                total_num: 0,
                minDate: new Date(2019, 0, 1),
                maxDate: new Date(2030, 0, 31),
                date: '',
                show:false,
            }
        },
        created: function () {
            document.title = this.$t('title.time_length_query');
            this.date = this.$t('column.default_month');
            this.requestLiveTime(0, 0);
        },
        methods: {
            onConfirm(date) {
                const [start, end] = date;
                this.show = false;
                this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;

                var startTime = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
                var endTime = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();
                this.requestLiveTime(startTime, endTime);
            },
            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            requestLiveTime: function (startTime, endTime) {
                const token = this.$route.query.token
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=emcee_center&act=get_emcee_center_live_time", {
                    params: {
                        token: token,
                        start_time: startTime,
                        end_time: endTime,
                    }
                }).then(res => {
                    console.log(res.data);
                    this.total_num = res.data.live_len;
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/emcee_center_select_live_time.vue